export default "__VITE_PUBLIC_ASSET__4627ce21__"